import React, { Component, FormEvent } from 'react';
import APSection from "../../atoms/APSection";
import APHeading from "../../atoms/APHeading";
import APButton from "../../atoms/APButton";
import APToolTip from "../../atoms/APToolTip";
import APLoadingBar from "../APLoadingBar";
import { withStyles, WithStyles } from "@mui/styles";
import { Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import classnames from 'classnames';
import { withNavigation, withTenant, withTranslate } from "../../../core/TenantProvider";
import APExpandingPanelsSectionStyles from "./styles/APExpandingPanelsSection.style";

import { ReactComponent as PassportIcon } from "./assets/icons/PassportIcon.svg";
import { ReactComponent as NICIcon } from "./assets/icons/NICIcon.svg";
import { ReactComponent as DrivingIcon } from "./assets/icons/DrivingIcon.svg";
import { ReactComponent as OtherIcon } from "./assets/icons/OtherIcon.svg";
import { ReactComponent as BankIcon } from "./assets/icons/BankIcon.svg";
import { ReactComponent as UtilityIcon } from "./assets/icons/UtilityIcon.svg";
import { ReactComponent as PhoneIcon } from "./assets/icons/PhoneIcon.svg";
import { ReactComponent as OtherPOAIcon } from "./assets/icons/OtherPOAIcon.svg";
import { ReactComponent as BlueTickIcon } from "./assets/icons/icon-tick-circle.svg";
import ErrorIcon from "../APPOIExpandingPanels/assets/icons/icon-error.svg";
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { actions as servicesDowntimeAction } from '../../../redux/modules/servicesDowntime';
import Cookies from 'js-cookie';

const ExpansionPanel = withStyles({
    root: {
        padding: "10px 15px",
        border: '1px #E8E8E8 solid',
        borderRadius: 4,
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: '16px 0',
            border: "1px #2691e9 solid",
        }
    },
    expanded: {},
})(Accordion);

const ExpansionPanelSummary = withStyles({
    root: {
        padding: 0,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        listStyle: "none"
    },
    content: {
        margin: "0",
        '&$expanded': {
            margin: "0 0 10px",
        },
    },
    expanded: {}
})(AccordionSummary);

const ExpansionPanelDetails = withStyles((theme) => ({
    root: {
        padding: 0
    },
}))(AccordionDetails);

const acceptedTypes: string[] = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/pdf'
];

const IDENTITY_DOCUMENT_MAPPING = {
    'poi.Passport': 'passport',
    'poi.NationalIdentityCard': 'nationalIdCard',
    'poi.DrivingLicense': 'drivingLicense',
    'poi.OtherDocument': 'other',
    'poa.BankDocument': 'bankStatement',
    'poa.UtilityDocument': 'utilityBill',
    'poa.PhoneBillDocument': 'phoneBill',
    'poa.OtherDocument': 'other'
};

interface DocumentsExpandingPanelsProps extends WithStyles<typeof APExpandingPanelsSectionStyles> {
    translate: Function,
    post: Function,
    updateRegisterCustomerStatus: Function,
    uploadDocument: Function,
    toggleSlidingRightPanelStatus: Function,
    handleDocumentUpload: Function,
    navigate: any,
    accountType: string,
    type: string,
    uploadURL: string,
    singleParagraph: boolean,
    singleAccDocuments: any,
    getServicesErrorObj: Function
}

interface DocumentsExpandingPanelsState {
    expanded: any,
    fileName: string,
    fileSize: number,
    uploaded: boolean,
    uploading: boolean,
    uploadedDocumentsCount: number,
    errorMessage: boolean,
    acceptedFileTypeMessage: boolean,
    fileSizeMessage: boolean,
    onChangeFileStatus: boolean,
    fileIndex: boolean
}



class APExpandingPanelsSection extends Component<DocumentsExpandingPanelsProps, DocumentsExpandingPanelsState> {
    constructor(props) {
        super(props);

        this.state = {
            expanded: '',
            fileName: '',
            fileSize: 0,
            uploaded: false,
            uploading: false,
            uploadedDocumentsCount: 0,
            errorMessage: false,
            acceptedFileTypeMessage: false,
            fileSizeMessage: false,
            onChangeFileStatus: false,
            fileIndex: false
        };

        this.handlePanelLinkClick = this.handlePanelLinkClick.bind(this);
        this.onReturn = this.onReturn.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handlePanelLinkClick(sliderType: string, componentData?: any) {
        this.props.toggleSlidingRightPanelStatus(true, sliderType, componentData);
    }

    onReturn() {
        this.props.navigate('/register_client');
        this.props.updateRegisterCustomerStatus();
    }

    handleChange(panel: string) {
        return ((event: React.ChangeEvent<{}>, newExpanded: boolean) => {
            this.setState({
                expanded: newExpanded ? panel : false
            });
        });
    }

    getBase64(img: Blob, callback: any) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    handleFileUpload(e: FormEvent<HTMLFormElement>, fileTypeExtension: string, base64ImageURI: string) {
        e.preventDefault();

        const data = {
            "document_type": this.props.type,
            "file_type": fileTypeExtension,
            "base64_encoded_stream": base64ImageURI,
            "comments": "real account"
        };
        this.setState({
            uploading: true
        }, () => {
            const {
                uploadedDocumentsCount
            } = this.state;

            const {
                getServicesErrorObj
            } = this.props;

            this.props.uploadDocument("/v1" + this.props.uploadURL, data)
                .then((resp: any) => {
                    this.setState({
                        uploaded: true,
                        uploading: true,
                        uploadedDocumentsCount: uploadedDocumentsCount + 1
                    }, () => {
                        this.props.handleDocumentUpload(this.props.accountType, this.props.type, this.state.uploadedDocumentsCount);
                    });
                })
                .catch((error: any) => {
                    console.error(error);
                    getServicesErrorObj(error);
                });
        });
    }

    render() {

        const {
            classes,
            translate,
            type,
            // uploadURL,
            singleParagraph,
        } = this.props;

        const {
            expanded,
            uploaded,
            uploading,
            errorMessage,
            acceptedFileTypeMessage,
            fileSizeMessage,
            fileIndex,
            fileName,
            fileSize,
        } = this.state;

        const formSectionSubHeadingCls = classnames(classes.formSectionSubHeading, {
            [classes.formSectionSubHeadingPoa]: type === "POA"
        });

        const poiDocuments = [
            { label: translate('poi.bulletpoint.one'), linkText: "", link: "", icon: <PassportIcon />, type: "poi.Passport" },
            { label: translate('poi.bulletpoint.two'), linkText: "", link: "", icon: <NICIcon />, type: "poi.NationalIdentityCard" },
            { label: translate('poi.bulletpoint.three'), linkText: "", link: "", icon: <DrivingIcon />, type: "poi.DrivingLicense" },
            { label: translate('poi.bulletpoint.four'), linkText: translate("poi.list.link"), link: "/myLink", icon: <OtherIcon />, type: "poi.OtherDocument" },
        ]

        const poaDocuments = [
            { label: translate('poa.bulletpoint.one'), linkText: "", link: "", icon: <BankIcon />, toolTip: "", type: "poa.BankDocument" },
            { label: translate('poa.bulletpoint.two'), linkText: "", link: "", icon: <UtilityIcon />, toolTip: "", type: "poa.UtilityDocument" },
            { label: translate('poa.bulletpoint.three'), linkText: "", link: "", icon: <PhoneIcon />, toolTip: "", type: "poa.PhoneBillDocument" },
            { label: translate('poa.bulletpoint.four'), linkText: "", link: "", icon: <OtherPOAIcon />, toolTip: translate("register.customer.poa.tooltip"), type: "poa.OtherDocument" },
        ];

        let drawerData: any;

        if (type === 'POI') {
            drawerData = poiDocuments;
            if (Cookies.get('POI') === undefined || Cookies.get('POI') === "") {
                Cookies.set('POI', 'POI');
            }
        }
        if (type === 'POA') {
            drawerData = poaDocuments;
            if (Cookies.get('POA') === undefined || Cookies.get('POA') === "") {
                Cookies.set('POA', 'POA');
            }
        }

        let sectionHeading: any = '';

        // TODO - Add translations
        if (type === 'POI') {
            sectionHeading = <APHeading className={classes.formSectionHeading} variant="body1">{translate('poi.heading')}</APHeading>;
        }

        if (type === 'POA') {
            sectionHeading = <APHeading className={classes.formSectionHeading} variant="body1">{translate('poa.heading')}</APHeading>;
        }

        return (
            <APSection className={classes.formSection}>
                <div className={classes.formSectionHeader}>
                    {sectionHeading}
                    {singleParagraph ?
                        <>
                            <APHeading className={formSectionSubHeadingCls} variant="body1">
                                {type === "POI" ? translate('poi.sub.paragraph.only') : translate('poa.sub.paragraph.only.part.one')}
                            </APHeading>
                            {type === "POA" && <APHeading className={classes.formSectionSubHeading} variant="body1">{translate('poa.sub.paragraph.only.part.two')}</APHeading>}
                        </>
                        :
                        <>
                            <APHeading className={classes.formSectionSubHeading} variant="body1">
                                {type === "POI" ? translate('poi.sub.paragraph.one') : translate('poa.sub.paragraph.one')}
                            </APHeading>
                            <APHeading className={classes.formSectionSubHeading} variant="body1">
                                {type === "POI" ? translate('poi.sub.paragraph.two') : translate('poa.sub.paragraph.two')}
                            </APHeading>
                            <APHeading className={classes.formSectionSubHeading} variant="body1">
                                {type === "POI" ? translate('poi.sub.paragraph.three') : translate('poa.sub.paragraph.three')}
                            </APHeading>
                        </>
                    }
                </div>
                {drawerData.map((item: any, index: any) => (
                    <>
                        {
                            item.linkText &&
                            <APButton
                                className={expanded ?
                                    [classes.textButton, classes.textButtonOpen].join(' ') :
                                    [classes.textButton, classes.textButtonClosed].join(' ')
                                }
                                onClick={() => this.handlePanelLinkClick('poiDocuments')}
                                data-testid="handleclick"
                                color="primary"
                            >
                                {item.linkText}
                            </APButton>
                        }
                        {
                            item.toolTip &&
                            <div className={classes.toolTip}>
                                <APToolTip toolTipMessage={item.toolTip} />
                            </div>
                        }
                        <ExpansionPanel
                            key={index}
                            className={classes.poiBulletPoints} square
                            expanded={expanded === `panel${index}`}
                            onChange={this.handleChange(`panel${index}`)}>

                            <ExpansionPanelSummary
                                aria-controls={`panel${index}d-content`}
                                id={`panel${index}d-header`}>
                                <li className={classes.poiBullet}>
                                    <span className={classes.poiBulletImage}>{item.icon}</span>
                                    <span className={classes.poiLabel}>{item.label}</span>
                                </li>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <BlueTickIcon className={[item.toolTip ? classes.withToolTip : classes.withoutToolTip, classes.blueTick].join(' ')} />
                                <form className={classes.form}>
                                    {uploading ? null : (
                                        <>
                                            {errorMessage && (
                                                <div className={classes.invalidFileTypes}>
                                                    <img className={classes.errorIcon} src={ErrorIcon} alt="Error" />
                                                    <span className={classes.errorMessage}>
                                                        {acceptedFileTypeMessage && (
                                                            <>
                                                                <strong>{translate('register.customer.identity.supported.files.message.strong')}</strong>
                                                                {translate('register.customer.identity.supported.files.message')}
                                                            </>
                                                        )}
                                                        {fileSizeMessage && (
                                                            <strong>{translate('register.customer.identity.file.size.message')}</strong>
                                                        )}
                                                    </span>
                                                </div>
                                            )}
                                            <Button
                                                type="button"
                                                variant="contained"
                                                className={classes.uploadButton}
                                            >
                                                <input
                                                    className={classes.fileInput}
                                                    type="file"
                                                    name="file"
                                                    id={`upload-document-input-${index}-${type}`}
                                                    accept={acceptedTypes.toString()}
                                                    onChange={(e: any) => {
                                                        if (e.target.files && e.target.files.length > 0) {
                                                            const selectedFile = e.target.files[0],
                                                                uploadingFileName = e.target.files[0].name,
                                                                fileType = e.target.files[0].type,
                                                                fileTypeExtension = fileType.split("/").pop(),
                                                                maxFileSize: number = 10240,
                                                                roundedFileSize: number = Math.round((e.target.files[0].size / 1024) * 10) / 10;

                                                            if (acceptedTypes.indexOf(fileType) >= 0 && roundedFileSize < maxFileSize) {
                                                                this.setState({
                                                                    fileIndex: index,
                                                                    errorMessage: false,
                                                                    acceptedFileTypeMessage: false,
                                                                    fileSizeMessage: false,
                                                                    uploading: true,
                                                                    fileName: (uploadingFileName).toUpperCase(),
                                                                    fileSize: roundedFileSize,
                                                                }, () => {
                                                                    this.getBase64((selectedFile), (uri: string) => {
                                                                        const base64ImageURI = uri.split(',')[1];
                                                                        this.handleFileUpload(e, fileTypeExtension.toUpperCase(), base64ImageURI);
                                                                    });
                                                                });

                                                            } else {
                                                                this.setState({
                                                                    errorMessage: true,
                                                                    acceptedFileTypeMessage: acceptedTypes.indexOf(fileType) < 0,
                                                                    fileSizeMessage: roundedFileSize >= maxFileSize,
                                                                });
                                                            }
                                                        }
                                                    }}
                                                />
                                                <label htmlFor={`upload-document-input-${index}-${type}`}
                                                    className={classes.fileInputLabel}>{translate("poi.upload.file.button.label")}</label>
                                            </Button>
                                        </>
                                    )}
                                    {type === "POI" && index === fileIndex && uploading && (<APLoadingBar fileName={fileName} fileSize={fileSize} uploaded={uploaded} />)}
                                    {type === "POA" && index === fileIndex && uploading && (<APLoadingBar fileName={fileName} fileSize={fileSize} uploaded={uploaded} />)}
                                </form>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </>
                ))
                }
            </APSection>
        )
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default (
    withNavigation(
        withTenant(
            withTranslate(
                withStyles(APExpandingPanelsSectionStyles)(
                    connect(null, mapDispatchToProps)(APExpandingPanelsSection)
                )
            )
        )
    )
);
